import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = ["disabled"]
const _hoisted_2 = {
  key: 0,
  class: "pi pi-spinner pi-spin"
}
const _hoisted_3 = { key: 2 }

import { computed } from 'vue';

// A custom pill button styled entirely with Tailwind `tw3-primary-*`/`tw3-surface-*`
// utilities, so the page's inline theme color applies to it (unlike PrimeVue
// buttons, whose --p-primary-* tokens are anchored to :root and don't inherit
// the scoped override).

export default /*@__PURE__*/_defineComponent({
  __name: 'BookingButton',
  props: {
    label: { default: '' },
    icon: { default: '' },
    iconPos: { default: 'left' },
    variant: { default: 'primary' },
    size: { default: 'normal' },
    disabled: { type: Boolean, default: false },
    loading: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props;

const variantClass = computed(() => {
	switch (props.variant) {
		case 'secondary':
			return 'tw3-border tw3-border-surface-300 tw3-bg-surface-0 tw3-text-surface-700 hover:tw3-bg-surface-100';
		case 'text':
			return 'tw3-text-surface-600 hover:tw3-bg-surface-100';
		default:
			return 'tw3-bg-primary-600 tw3-text-white tw3-shadow-sm hover:tw3-bg-primary-700';
	}
});

const sizeClass = computed(() =>
	props.size === 'small'
		? 'tw3-px-3.5 tw3-py-2 tw3-text-xs'
		: 'tw3-px-5 tw3-py-2.5 tw3-text-sm'
);

const isDisabled = computed(() => props.disabled || props.loading);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    class: _normalizeClass(["tw3-inline-flex tw3-items-center tw3-justify-center tw3-gap-2 tw3-rounded-full tw3-font-semibold tw3-transition-all focus:tw3-outline-none disabled:tw3-pointer-events-none disabled:tw3-opacity-60", [variantClass.value, sizeClass.value]]),
    disabled: isDisabled.value,
    type: "button"
  }, [
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("i", _hoisted_2))
      : (_ctx.icon && _ctx.iconPos === 'left')
        ? (_openBlock(), _createElementBlock("i", {
            key: 1,
            class: _normalizeClass(_ctx.icon)
          }, null, 2))
        : _createCommentVNode("", true),
    (_ctx.label)
      ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.label), 1))
      : _createCommentVNode("", true),
    (!_ctx.loading && _ctx.icon && _ctx.iconPos === 'right')
      ? (_openBlock(), _createElementBlock("i", {
          key: 3,
          class: _normalizeClass(_ctx.icon)
        }, null, 2))
      : _createCommentVNode("", true)
  ], 10, _hoisted_1))
}
}

})